<template>
  <section class="py-16 sm:py-24">
    <div class="container" data-aos="fade-up" data-aos-duration="2000">
      <div class="text-center">
        <h1 class="text-3xl/tight font-medium mt-3 mb-4">
          Sıkça Sorulan Sorular
        </h1>
        <p class="text-gray-500">
          Sistemimiz hakkında sıkça sorulan soruları buradan bulabilirsiniz.
        </p>
      </div>

      <div data-fc-type="accordion" class="mt-14 lg:w-3/4 lg:mx-auto 2xl:w-2/3">
        <!-- 1 -->
        <div
          class="border border-gray-300 rounded-lg"
          v-for="(faq, index) in faqsStore.faqs"
          :key="index"
        >
          <button
            @click="toggleFaq(index)"
            class="inline-flex p-5 items-center justify-between w-full font-semibold text-left transition"
            data-fc-type="collapse"
          >
            {{ faq.Question }}
            <span
              class="material-symbols-rounded text-xl block transition-transform"
              :class="{ 'rotate-180': openFaq[index] }"
            >
              <i class="fa-solid fa-angle-down"></i>
            </span>
          </button>
          <div
            v-if="openFaq[index]"
            class="w-full overflow-hidden transition-[height] duration-300"
          >
            <p class="text-gray-700 dark:text-gray-300 pt-3 p-5">
              {{ faq.Answer }}
            </p>
          </div>
        </div>
      </div>

      <div class="text-center mt-14">
        <p
          class="inline-flex flex-wrap gap-1 bg-gray-100 text-sm rounded-lg py-2 px-5"
        >
          Hala Sorularınız mı var?
          <router-link to="/contact-us" class="text-primary transition-all">
            Bizimle İletişime Geçin
          </router-link>
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useFaqsStore } from "@/stores/faqsStore";
import { ref } from "vue";

const faqsStore = useFaqsStore();
const openFaq = ref(Array(faqsStore.faqs.length).fill(false));

const toggleFaq = (index) => {
  openFaq.value[index] = !openFaq.value[index];
};
</script>
